import React from "react";

export const DocumentIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width ?? 24}
    height={props.height ?? 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7.42829 12H13.1426M7.42829 14.2857H15.4283M7.42829 16.5714H10.8569M18.8569 17.7143V9.71429L13.1426 4H7.42829C6.82208 4 6.2407 4.24082 5.81205 4.66947C5.38339 5.09812 5.14258 5.67951 5.14258 6.28571V17.7143C5.14258 18.3205 5.38339 18.9019 5.81205 19.3305C6.2407 19.7592 6.82208 20 7.42829 20H16.5712C17.1774 20 17.7587 19.7592 18.1874 19.3305C18.616 18.9019 18.8569 18.3205 18.8569 17.7143Z" stroke={props.stroke ?? "currentColor"} strokeWidth={props.strokeWidth ?? 1.14286} strokeLinecap="round" strokeLinejoin="round"/>
<path d="M13.1426 4V7.42857C13.1426 8.03478 13.3834 8.61616 13.812 9.04482C14.2407 9.47347 14.8221 9.71429 15.4283 9.71429H18.8569" stroke={props.stroke ?? "currentColor"} strokeWidth={props.strokeWidth ?? 1.14286} strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default DocumentIcon;
